import { render } from "./EditArticleInformation.vue?vue&type=template&id=28c2d784&scoped=true"
import script from "./EditArticleInformation.vue?vue&type=script&lang=js"
export * from "./EditArticleInformation.vue?vue&type=script&lang=js"

import "./EditArticleInformation.vue?vue&type=style&index=0&id=28c2d784&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c2d784"]])

export default __exports__